// Keep in sync with _app.tsx
export enum FontVariableName {
  DmSans = "--dm-sans",
  WorkSans = "--work-sans",
}
